import { toegangClientSecret } from '@thiememeulenhoff/nx-sdk';
import { Environment } from '@thiememeulenhoff/types';
import { deployUrl } from '@thiememeulenhoff/ng-sdk';
import { EnvironmentType } from './environment.type';

export const environment: EnvironmentType = {
  environment: Environment.Production,
  production: true,
  localParsingEnabled: false,
  deployUrl: deployUrl(),
  datadog: {
    applicationId: '487624e5-b6b5-40f9-b0bb-d774a9902053',
    clientToken: 'pub4b3d1aaff88846caa4b1b81468f30005',
    env: Environment.Production,
    sessionSampleRate: 0.5,
    sessionReplaySampleRate: 0,
  },
  unleash: {
    instance: 'eu.app.unleash-hosted.com/euee0007',
    clientKey:
      '*:production.5f8928ceb399f8c72cd7e889f7c11193ee173f652b5595c5c1a71d38',
    environment: 'production',
    refreshInterval: 5 * 60, // 5 minutes
    metricsInterval: 15 * 60, // 15 minutes
  },
  analytics: {
    tagManagerId: 'GTM-P4XBW2XB',
    tagManagerAuth: 'hwpqd3EVbI5gdjgFiVBNtQ',
    tagManagerPreview: 'env-1',
  },
  thas: {
    environment: 'prod',
    token: '49e1d073f61072911105cf24c91c799860b685637e3d33fc24d049cf19228864',
  },
  auth: {
    environment: Environment.Production,
    clientId: 'edu-admin',
    clientSecret: toegangClientSecret('EDU_ADMIN'),
    useUserCookie: false,
  },
  tham: {
    proxyDomain: 'https://d3c9bg8z45r18r.cloudfront.net',
  },
  thiemo: 'https://thiemo.thiememeulenhoff.nl/secure',
  mboDocent: 'https://mbodocent.thiememeulenhoff.nl/secure',
  cockpit: 'https://cockpit.thiememeulenhoff.nl',
  edition: 'https://edition.thiememeulenhoff.nl',
  myTM: 'https://mijn.thiememeulenhoff.nl',
  mockData: false,
  groupServices: {
    demoGroupId: '4375514',
    demoGroupCode: 'JLPQ',
  },
  wilmaEndpoint: 'https://wilma.thiememeulenhoff.nl',
};
